import { render } from "./MonthlyWorkVendorList.vue?vue&type=template&id=33ec2866&scoped=true"
import script from "./MonthlyWorkVendorList.vue?vue&type=script&lang=js"
export * from "./MonthlyWorkVendorList.vue?vue&type=script&lang=js"

import "./MonthlyWorkVendorList.vue?vue&type=style&index=0&id=33ec2866&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ec2866"]])

export default __exports__